module.exports = __webpack_public_path__ + "static/media/Whatsapp.c91cc23c.png";